import { AutocompleteItem, Card, CardBody, Button, Input, Select, SelectItem, Autocomplete, Checkbox } from "@heroui/react"
import { ErrorCard, LoadingCard, MainContainer } from "../../components"
import { useEffect, useMemo, useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import * as XLSX from 'xlsx';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faDiamond, faDownload, faGem, faHexagonNodes, faList, faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import { apiRoute, ENUM_ADVSEARCH_PARAM, ENUM_CERTIFIED_FROM, ENUM_CERTIFIEDLAB, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, getModMandatory, getModValue, linksUrl, URIEncrypt } from "../../constants/enum";
import { useFetchWithBody, usePost, usePostMutateWithSuccess } from "../../api/reactQueryCustomHooks";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import { focusManager } from "@tanstack/react-query";
import NextUITable, { COLUMN_ALIGN_TYPE, COLUMN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { setStockParamUploadDetail, setUploadParamNewEntryMode } from "../../state/stockEntrySlice";
import { useModalToast } from "../../components/modalToast/ModalToastContext";

const UploadStockParam = () => {
    const { compCode, } = useSelector((state) => state.company)
    const { isUploadParamNewEntry } = useSelector((state) => state.stockEntry)
    const { user } = useSelector((state) => state.auth);
    const [excelData, setExcelData] = useState([])
    const [mappedData, setMappedData] = useState([])
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [mktLotNo, setMktLotNo] = useState("0")
    const [selUpdateKey, setSelUpdateKey] = useState("")
    const [isRegenMktNo, setIsRegenMktNo] = useState(false)
    const [dupMfgCode, setDupMfgCode] = useState([])
    const [notExistMfglotPkt, setnotExistMfglotPkt] = useState([])
    const [isMFGIdSingleColum, setIsMFGIdSingleColum] = useState(true)
    const [totalExcelPacket, setTotalExcelPacket] = useState(0)
    const [isNewUpload, setIsNewUpload] = useState(0)
    const [selAdvanceFilter, setSelAdvanceFilter] = useState({})
    const [pageApiAdvFilter, setPageApiAdvFilter] = useState({})
    const [defaultStkAt, setDefaultStkAt] = useState("")
    const navi = useNavigate();
    const disapatch = useDispatch();
       const { show } = useModalToast();
    const fileInputRef = useRef()
    const ENUM_REPORT_TYPE = [{
        key: "RSLT", value: "RSLT",

    }]
    
    const submitLockRef=useRef(false)
    //{ key: "PRMUP", value: "PRMUP" }


    const INITIAL_VISIBLE_COLUMNS = [
        "actions",
        "CFNAME",
        "TOTALPKT",
        "R_DATE",
        "LABID",
    ]
    const columns = [
        {
            name: "Actions",
            uid: "actions",
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "FILE NAME",
            uid: "CFNAME",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "Total PKT",
            uid: "TOTALPKT",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "DATE",
            uid: "R_DATE",
            sortable: true,
            type: COLUMN_TYPE.date,
            align: COLUMN_ALIGN_TYPE.center,
        },
        {
            name: "CERTIFIED FROM",
            uid: "LABID",
            sortable: true,
            align: COLUMN_ALIGN_TYPE.center,
        },
    ]
    const rowActionBtn = [

        {
            icon: <FontAwesomeIcon color="#FFFFFF" icon={faGem} />,
            //1656e7
            onClick: (row) => {


                disapatch(setStockParamUploadDetail(row))
                navi(linksUrl.stockEntry.polishDiamond + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.stockEntry.parameterUpdateEntry,)


            },
            label: "View",
            color: "bg-red-700",
            type: ROW_ACTION_BTN_TYPE.button,
        },
    ]

    const downloadDataFooter = {
        CFNAME: "",
        TOTALPKT: "",
        R_DATE: "",
        LABID: "",

    }

    const exportColumns = [
        {
            name: "FILE NAME",
            uid: "CFNAME",
        },
        {
            name: "TOTAL PKT",
            uid: "TOTALPKT",
        },
        {
            name: "DATE",
            uid: "R_DATE",
        },
        {
            name: "CERTIFIED FROM",
            uid: "LABID",
        },
    ]
    const handleUploadNew = () => {
        setIsNewUpload(1)
        disapatch(setUploadParamNewEntryMode(true))

    }
    const handleChange = (e) => {
        const { value, name, } = e.target
        setFormData({ ...formData, [name]: value })
    }
    const { data: mktLotNoData = [], mutate: getMktLotNo } = usePost({
        url: apiRoute.memoEntry.fetchMktlotNo,
        queryKey: "getmktlocdeData",
        onSuccessTasks: (data) => {
            if (!isUseMfgNoAsMktno) {
                if (data && data.length <= 0) {
                    if (!toast.isActive("mktlcode")) {
                        toast.error("Lot No Series Not Found", {
                            "position": "top-center",
                            toastId: "mktlcode"
                        })
                    }
                    setFormData({ ...formData, "rDate": null })
                }
                else
                    setMktLotNo(data[0].Mkt_LCode)
            }
            else
                setMktLotNo('0')
        }

    })
    const funMktLotNo = (date) => {
        if (!isUseMfgNoAsMktno) {
            getMktLotNo({
                data: {
                    chaldate: date
                }
            })
        }
    }
    useEffect(() => {

        funMktLotNo(dayjs(Date()).format("YYYY-MM-DD"))

    }, [isUseMfgNoAsMktno])
    const { data: filterData = [], mutate: paramFilter } = usePost({
        url: apiRoute.stockEntry.getUploadParamList,
        queryKey: "fetchUploadParamsData"

    })
    const funFilterData = (lotno, pktno, ismfgno, scode, qcode, shcode, fromdate, todate) => {
        paramFilter({
            data: {
                comp_code: compCode.join(","),
                l_code: lotno,
                pkt_no: pktno,
                is_mfgno: ismfgno,
                s_code: scode,
                q_code: qcode,
                sh_code: shcode,
                from_date: fromdate,
                to_date: todate
            }
        })
    }
    useEffect(() => {
        funFilterData(null, null, null, null, null, null, null, null)
        setPageApiAdvFilter({ CompCode: compCode.join(','), BillType: 'S', TradeOf: 'P' })
    }, [])
    const handleAutoCompleteChange = (value, name) => {
        setFormData({ ...formData, [name]: value })
        let Execl_Templ = value
        if (value == ENUM_CERTIFIED_FROM.CUSTOM) {
            Execl_Templ = "Stock_ParamUpdate_Custom"
        }
        if (Execl_Templ != "") {

            filterXlTemplate({
                data: {
                    tempname: Execl_Templ
                }
            })
        }
    }
    const handleUpdateKeyChange = (val) => {
        setSelUpdateKey(val)
        if (val == 1 && (formData.fileName == '' || formData.fileName == null)) {
            setIsRegenMktNo(false)
            toast.error("First select File To Upload", {
                "position": "top-center"
            })
        }
        else
            if (val == 0) setIsRegenMktNo(false)

    }
    const handleDateChange = (newValue) => {

        const rdate = newValue != '' && newValue != 'Invalid Date' ? dayjs(newValue).format("YYYY-MM-DD") : null

        setFormData((prev) => {
            return {
                ...prev,
                "rDate": rdate,
            };
        });
        if (rdate && rdate != "Invalid Date") {
            funMktLotNo(rdate)
        }
    }

    const handleDateBlur = (e, name) => {
        const input = e.target.value.trim();   // "DD/MM/YYYY"

        if (!input) return;

        // Parse typed date strictly as DD/MM/YYYY
        const parsed = dayjs(input, "DD/MM/YYYY", true);

        // ❌ Invalid format or wrong date typed
        if (!parsed.isValid()) {
            toast.error("Invalid date format. Use DD/MM/YYYY", {
                position: "top-center",
                className: "toast-error"
            });
            return;
        }

        const formatted = parsed.format("YYYY-MM-DD");


        setFormData(prev => {
            const updated = { ...prev, [name]: formatted };
            return updated;
        });
        if (formatted && formatted != "Invalid Date") {
            funMktLotNo(formatted)
        }
    };
    const { data: modSetting = [], } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingInwardItem",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings,
        }
    })
    const { data: stockLocData = [], } = useFetchWithBody({
        url: apiRoute.stockEntry.getStockLocationList,
        queryKey: "fetchStocklocation",
        inputData: {
            compcode: compCode.join(","),
        }
    })
    const [formData, setFormData] = useState({
        certifiedFrom: "",
        rDate: new Date().toISOString().split("T")[0],
        reportType: "",
        fileName: "",
        location: ""
    })
    const { data: excelTempData, mutate: filterXlTemplate } = usePost({
        url: apiRoute.stockEntry.getExcelTemplate,
        queryKey: "funExcelTemplateStock",

    })
    const { isPending: isLoadingDupPktList, data: dupPktList = [], mutate: funGetDupPktList } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.getDupPktList,
        queryKey: "funDupPktStock",
    })
    const { isPending: isLoadingNotExistPktList, data: notExistPktList = [], mutate: funGetNotExistLotPktList } = usePostMutateWithSuccess({
        url: apiRoute.stockEntry.getNotExistLotPktList,
        queryKey: "funNotExistPktStock",
    })
    const { isPending, isError, mutate: funUpdateParam } = usePost({
        url: apiRoute.stockEntry.updateParam,
        queryKey: "funUpdateStockParam",
        onSuccessTasks: (data) => {
            toast.success("Parameter Updated ", {
                position: "top-center"
            })
            submitLockRef.current = false
        }

    })
    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
            setIsUseMfgNoAsMktno(mktSetting)
            setIsMFGIdSingleColum(getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.IsMfgIDSingleColumn, modSetting) ?? true);
            const dStkAt = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.DefaultStockDiv, modSetting);
            setDefaultStkAt(dStkAt || "")
        }

    }, [modSetting])

    const columnMapping = useMemo(() => {
        const d = excelTempData.map((row) => {
            return {
                [row.xl_col_no]: row.tb_col_name
            }
        })

        const flipped = d.reduce((acc, obj) => {
            const [key, value] = Object.entries(obj)[0];
            acc[value] = key;
            return acc;
        }, {});
        return flipped
    }, [excelTempData])
    //console.log(excelTempData)
    useEffect(() => {
        if (isRegenMktNo) {
            setFormData({ ...formData, location: defaultStkAt })
            const allHaveKeys = excelData.every(
                obj => obj.hasOwnProperty("l_code") && obj.hasOwnProperty("pktno")
            );
            if (allHaveKeys) {
                let mapLotPktList = []
                if (isMFGIdSingleColum)
                    mapLotPktList = excelData.map((ele) => ele.stoneid)
                else
                    mapLotPktList = excelData.map((ele) => ele.l_code + "-" + ele.pktno)
                funGetDupPktList({
                    data: {
                        compcode: compCode.join(","),
                        list: mapLotPktList.join(","),
                        Ismfglist: 1,
                        Ischkmfgmkt: 1
                    },
                    onSuccess: (data) => {
                        if (data && data.length > 0) {

                            if (!isUseMfgNoAsMktno) {

                                setDupMfgCode(data);

                                // const filtered = mappedData.filter(item =>
                                //     !dupMfgCode.some(ex =>
                                //         ex.SPKTNO === item.pktno && ex.SL_CODE === item.l_code
                                //     )
                                // );
                                // // console.log(filtered,"df",data)
                                // setExcelData(filtered);
                            }
                        }
                        else
                            setDupMfgCode([]);

                    }
                })
                funGetNotExistLotPktList({
                    data: {
                        compcode: compCode.join(","),
                        list: mapLotPktList.join(","),
                        Ismfglist: 1,
                        Ischkmfgmkt: 1
                    },
                    onSuccess: (data) => {
                        if (data && data.length > 0) {

                            if (!isUseMfgNoAsMktno) {

                                setnotExistMfglotPkt(data);

                                // const filtered = mappedData.filter(item =>
                                //     !dupMfgCode.some(ex =>
                                //         ex.SPKTNO === item.pktno && ex.SL_CODE === item.l_code
                                //     )
                                // );
                                // // console.log(filtered,"df",data)
                                // setExcelData(filtered);
                            }
                        }
                        else
                            setnotExistMfglotPkt([]);

                    }
                })
            }

        }
        else {
            setFormData({ ...formData, location: "" })
        }
    }, [isRegenMktNo, excelData])
    //console.log(  const jsonData = JSON.stringify(mapped);
    //                     const jsonSize = new Blob([mapped]).size;)
    const handleFileUpload = (e) => {
        const file = e.target.files[0];

        if (formData.certifiedFrom != "") {
            const reader = new FileReader();
            reader.onload = (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: 'binary' });
                const worksheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[worksheetName];
                const jsonData = XLSX.utils.sheet_to_json(worksheet);
                const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                // setExcelData(jsonData);
                const dataRows = rows.slice(1); // remove this if there's no header row
                const headers = rows[0];
                // const finalRowsdata = dataRows.map((row) => {
                //     let rowObj = [];
                //     headers.forEach((header, i) => {
                //         // Fill missing or empty cells with "-"
                //         rowObj =[...rowObj, (row[i] !== undefined && row[i] !== null && row[i] !== "") ? row[i] : "-"]
                //     });
                //     return rowObj;
                // });
                //console.log(headers, dataRows, columnMapping)
                setTotalExcelPacket(dataRows.length)
                if (headers.length == Object.keys(columnMapping).length) {
                    if (dataRows && dataRows?.length > 0) {
                        const { name } = file
                        const fileName = name.substring(0, name.lastIndexOf('.')) || name;
                        setFormData({ ...formData, fileName: fileName })
                    }
                    const mapped = dataRows.filter((r) => r.length !== 0).map((row) => {
                        const finalData = Object.entries(columnMapping).map(([key, value]) => {
                            if (key == 'stoneid') {

                                let val = row[Number(value.toString()) - 1] ?? ''
                                if (val != "") {
                                    if (String(val).includes("-")) {
                                        const [left, right] = String(val).split("-");
                                        if (left?.trim() && right?.trim()) {
                                            return { l_code: left, pktno: right, [key]: row[Number(value.toString()) - 1] ?? null }
                                        }
                                        else return { [key]: row[Number(value.toString()) - 1] ?? null }
                                    }
                                    else {
                                        if (toast && !toast.isActive("stkinval")) {
                                            toast.error("Invalid Stock Format LotNo & PktNo Must Be Seperated Using ' - '  ", {
                                                "position": "top-center",
                                                "className": "toast-error",
                                                "toastId": "stkinval"
                                            })
                                        }
                                        if (fileInputRef.current) {
                                            fileInputRef.current.value = ''; // Clear file input
                                        }
                                        return { [key]: row[Number(value.toString()) - 1] ?? null }
                                    }
                                }
                            }
                            else {
                                if (columnMapping.hasOwnProperty('labid')) {
                                    return {
                                        [key]: row[Number(value.toString()) - 1] ?? null,
                                    }
                                }
                                return {
                                    [key]: row[Number(value.toString()) - 1] ?? null,
                                    ["labid"]: formData?.certifiedFrom == ENUM_CERTIFIED_FROM.CUSTOM ? "" : formData?.certifiedFrom ?? ''
                                }
                            }


                        })

                        const result = finalData.reduce((acc, obj) => {
                            if (obj && typeof obj === 'object') {
                                Object.entries(obj).forEach(([key, value]) => {
                                    acc.push({ [key]: value });
                                });
                            }
                            return acc;
                        }, [])

                        const finalresult = result.reduce((acc, obj) => {
                            return { ...acc, ...obj }
                        })

                        return finalresult

                    });
                    const maxSize = 1 * 1024 * 1024; // 1MB NGNIX Limit

                    const jsonString = JSON.stringify(mapped);

                    // Calculate size in bytes

                    const sizeInBytes = new Blob([jsonString]).size;

                    if (sizeInBytes > maxSize) {
                        setExcelData([])
                        if (fileInputRef.current) {
                            fileInputRef.current.value = ''; // Clear file input
                        }
                        toast.error("Excel File data is too large!", {
                            position: "top-center",
                            className: "toast-error"
                        });
                        return;
                    }
                    setMappedData(mapped)
                    setExcelData(mapped)

                }
                else {
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ''; // Clear file input
                    }
                    show("Excel File No of Columns Mis-Match With Selected Certified From Format")
                }
            }
            reader.readAsBinaryString(file);
        }
        else {
            if (fileInputRef.current) {
                fileInputRef.current.value = ''; // Clear file input
            }
            toast.error("First Select Certified From", {
                position: "top-center",
                // className: "session-expired-dialog",
                // icon: false,           // remove icon
                // closeButton: true,     // keep close button (we will style it)
                // hideProgressBar: true, // remove progress bar
                // autoClose: false,      // disable auto close
                // closeOnClick: false,
            })
        }
    }

    const downloadTextFile = () => {
        let content = "Total No oF Packets:" + totalExcelPacket + "\n\n";

        let uploadPkt = excelData.length
        if (excelData.length > dupMfgCode.length)
            uploadPkt = excelData.length - (dupMfgCode.length + notExistMfglotPkt.length)


        content += "Total No oF New Packets :" + uploadPkt + "\n\n";
        if (dupMfgCode.length > 0)
            content += "Total No oF DupliCate Packets  :" + dupMfgCode.length + "\n\n";


        if (dupMfgCode?.length > 0) {
            content += "Duplicate Manufacturing Nos: ( " + dupMfgCode.length + " )\n";
            dupMfgCode.forEach((ele) => {
                content += `${ele.SL_CODE}-${ele.SPKTNO}, `;
            });
            content += "\n\n";
        }
        if (notExistMfglotPkt.length > 0) {
            content += "Not Exist In Stock Manufacturing Lot & Pkt No: ( " + notExistMfglotPkt.length + " )\n";
            notExistMfglotPkt.forEach((ele) => {
                content += `${ele.L_CODE}-${ele.PKTNO}, `;
            });
            content += "\n\n";
        }
        const today = new Date();
        const formattedDate = today.toISOString().slice(0, 10); // "2025-01-15"

        const fileName = `StockImportLogs-${formattedDate}.txt`

        const blob = new Blob([content], { type: "text/plain" });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;

        a.download = fileName
        a.click();

        URL.revokeObjectURL(url);
    };

    useEffect(() => {
        if (!isLoadingDupPktList && !isLoadingNotExistPktList) {

            if (
                (isRegenMktNo && (dupMfgCode && dupMfgCode.length > 0) || (notExistMfglotPkt && notExistMfglotPkt.length > 0))
            ) {
                downloadTextFile();   // auto download
            }
        }
    }, [dupMfgCode, isLoadingDupPktList, notExistMfglotPkt, isLoadingNotExistPktList]);

    const combineAll = (arr1, arr2) => {
        const map = new Map();

        // Array 1 → Duplicate list
        arr1.forEach(item => {
            const key = `${item.SL_CODE}-${item.SPKTNO}`;
            map.set(key, {
                L_CODE: item.SL_CODE,
                PKTNO: item.SPKTNO,
                //DuplicateCount: item.DuplicateCount ?? 0,
                // ExistCount: 0
            });
        });

        // Array 2 → Exist list
        arr2.forEach(item => {
            const key = `${item.L_CODE}-${item.PKTNO}`;

            // if (map.has(key)) {
            //     // merge into existing
            //     map.get(key).ExistCount = item.ExistCount ?? 0;
            // } else {
            // add new
            map.set(key, {
                L_CODE: item.L_CODE,
                PKTNO: item.PKTNO,
                // DuplicateCount: 0,
                //ExistCount: item.ExistCount ?? 0
            });
            //}
        });

        return Array.from(map.values());
    };
    //console.log(excelData)
    const handleSubmit = (e) => {
        e.preventDefault();
        if (!isUseMfgNoAsMktno && isRegenMktNo && (mktLotNo == '' || mktLotNo == null || mktLotNo == '0')) {
            toast.error("Marketing Lot No Series Not Found", {
                "position": "top-center",
            })
            return;
        }
        let ExcelRow = excelData
        if (submitLockRef.current) return;
        submitLockRef.current = true;
        if (isRegenMktNo) {
            const dupAndNotExistData = combineAll(dupMfgCode, notExistMfglotPkt);

            if (dupAndNotExistData && dupAndNotExistData.length > 0) {
                const filtered = excelData.filter(item =>
                    !dupAndNotExistData.some(ex =>
                        ex.PKTNO === item.pktno && ex.L_CODE === item.l_code
                    )
                );
                ExcelRow = filtered

            }
            
            // if (dupMfgCode.length > 0) {

            //     const filtered = excelData.filter(item =>
            //         !dupMfgCode.some(ex =>
            //             ex.SPKTNO === item.pktno && ex.SL_CODE === item.l_code
            //         )
            //     );
            //     ExcelRow = filtered
            // }
        }
        //console.log(ExcelRow)
        funUpdateParam({
            data: {
                comp_code: compCode.join(","),
                r_date: formData.rDate,
                certified_from: formData.certifiedFrom, // formData.certifiedFrom == ENUM_CERTIFIED_FROM.CUSTOM ? "" : formData.certifiedFrom,
                report_type: isRegenMktNo ? formData.reportType : 'PRMUP',
                file_name: formData.fileName,
                params_data: ExcelRow,// excelData,
                login_userid: user.username,
                isexcel_upload: 1,
                mkt_lotno: isUseMfgNoAsMktno ? '0' : isRegenMktNo ? mktLotNo : selUpdateKey,
                is_regmktno: isUseMfgNoAsMktno ? 0 : isRegenMktNo ? 1 : 0,
                location: formData.location,
                rec_status: 2
            }
        })

    }

    const handleShow = () => {
        navi(linksUrl.stockEntry.polishDiamond + URIEncrypt.Polish + "/" + URIEncrypt.SinglePacket + linksUrl.stockEntry.parameterUpdateEntry,)
    }
    const handleCancle = () => {
        disapatch(setUploadParamNewEntryMode(false))
        setFormData({
            certifiedFrom: "",
            rDate: new Date().toISOString().split("T")[0],
            reportType: "",
            fileName: "",
            location: ""
        })
    }
    
    const handleDownloadExcel = () => {
        // File: ExportExcel.js
        // Define headersif()

        const data = [...excelTempData];

        const sortedData = data.sort((a, b) => Number(a.xl_col_no) - Number(b.xl_col_no));

        const headers = sortedData.map(ele => ele.xl_col_name)
        //if (headers && headers.length > 0) {
        //  Create a worksheet with headers only
        const ws = XLSX.utils.aoa_to_sheet([headers]);

        // Create a new workbook and append the worksheet
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate Excel file buffer
        const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });

        // Trigger download with FileSaver
        const blob = new Blob([wbout], { type: "application/octet-stream" });
        saveAs(blob, "CustomParameterUpdateFormat.xlsx");


    }
    const ADVFILTER_VISIBLE_FIELD = [
        // ...Object.values(ENUM_ADVSEARCH_PARAM)
        ENUM_ADVSEARCH_PARAM.Shape,
        ENUM_ADVSEARCH_PARAM.Purity,
        ENUM_ADVSEARCH_PARAM.Color,
        ENUM_ADVSEARCH_PARAM.VouFromDate,
        ENUM_ADVSEARCH_PARAM.VouToDate,
        ENUM_ADVSEARCH_PARAM.LotNo,
        ENUM_ADVSEARCH_PARAM.PktNo,
        ENUM_ADVSEARCH_PARAM.IsMfgNo
    ]
    const handleFilterChange = (newFilters) => {
        //console.log('Received filters in parent:', newFilters);
        setSelAdvanceFilter(newFilters)
        funFilterData(
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.LotNo) ? newFilters[ENUM_ADVSEARCH_PARAM.LotNo] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.PktNo) ? newFilters[ENUM_ADVSEARCH_PARAM.PktNo] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.IsMfgNo) ? newFilters[ENUM_ADVSEARCH_PARAM.IsMfgNo] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Shape) ? newFilters[ENUM_ADVSEARCH_PARAM.Shape] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Purity) ? newFilters[ENUM_ADVSEARCH_PARAM.Purity] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.Color) ? newFilters[ENUM_ADVSEARCH_PARAM.Color] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouFromDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouFromDate] : null,
            newFilters.hasOwnProperty(ENUM_ADVSEARCH_PARAM.VouToDate) ? newFilters[ENUM_ADVSEARCH_PARAM.VouToDate] : null,

        )

    };
    if (isError) {
        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }
    return (
        <MainContainer pageName={"Stock Parameter Update"}
            breadcrumbs={["Sinlge Packet Stock", "Parameter Update"]}
            prevPage={{
                show: true,
                onClick: handleCancle,
            }}
        >


            {isUploadParamNewEntry == false ? <div>
                <div className="flex justify-end ">
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faPlus} />}
                        onPress={handleUploadNew}
                    >
                        New Upload
                    </Button>
                </div>
                <NextUITable
                    INITIAL_VISIBLE_COLUMNS={INITIAL_VISIBLE_COLUMNS}
                    data={filterData}
                    columns={columns}
                    rowActionBtn={rowActionBtn}
                    exportColumns={exportColumns}
                    downloadDataFooter={downloadDataFooter}
                    downloadFileName={"UploadParamsData"}
                    onFilterChange={handleFilterChange}
                    showAdvancedFilter={true}
                    id="TransactionId"
                    advanceFilterParam={selAdvanceFilter}
                    advFilterPageApiParam={pageApiAdvFilter}
                    advFilterVisibleField={ADVFILTER_VISIBLE_FIELD}
                ></NextUITable>
            </div> : <div> <Card className="">
                <div className="m-3" style={{ textAlign: "right" }}>
                    <Button
                        size="sm"
                        color="primary"
                        startContent={<FontAwesomeIcon icon={faList} />}
                        onPress={handleShow}
                    >
                        Show Updated Packet
                    </Button>
                </div>
                <form onSubmit={handleSubmit} autoComplete='off'>
                    <CardBody>
                        <div className="flex gap-4 align-top items-baseline mb-2">
                            <Autocomplete
                                size="sm"
                                name={"certifiedFrom"}
                                label={"Certified From"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                //labelPlacement={"outside"}
                                placeholder={""}
                                isRequired
                                color="success"
                                className="max-w-23 font-semibold"
                                classNames={{
                                    label: "font-semibold",
                                }}
                                isClearable={false}
                                isVirtualized
                                // readonly={isNewEntry ? false : true}
                                defaultItems={
                                    ENUM_CERTIFIEDLAB
                                }
                                onSelectionChange={(e) =>
                                    handleAutoCompleteChange(e, "certifiedFrom")
                                }
                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                //onChange={handleFormSelectionChange}
                                selectedKey={formData.certifiedFrom}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.key}
                                    >
                                        {list.value}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    label={"Date"}
                                    views={["day", "month", "year"]}
                                    format="DD/MM/YYYY"
                                    value={
                                        formData["rDate"]
                                            ? dayjs(formData["rDate"])
                                            : formData["rDate"]
                                    }
                                    onChange={(newValue) => handleDateChange(newValue)}
                                    //     setFormData((prev) => {
                                    //         return {
                                    //             ...prev,
                                    //             ["rDate"]: newValue != '' && newValue != 'Invalid Date' ?
                                    //                 dayjs(newValue).format("YYYY-MM-DD") : null,
                                    //         };
                                    //     });
                                    // }}
                                    //isRequired={item.required}
                                    className="w-full "
                                    slotProps={{
                                        textField: { size: "small", required: true, onBlur: (e) => handleDateBlur(e, "rDate") },
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="flex gap-4 align-top items-center mb-2">
                            <Input type="file" ref={fileInputRef} color="danger" size="md" variant="flat"
                                isRequired
                                classNames={{ label: "text-lg text-slate-700 font-semibold" }}
                                label="Source File" accept=".xlsx, .xls" onChange={handleFileUpload} ></Input>

                            <Select
                                size="sm"
                                name={"reportType"}
                                className="max-w-23"
                                classNames={{
                                    label: " font-semibold text-sm",
                                }}
                                isMultiline={true}
                                isRequired
                                items={ENUM_REPORT_TYPE}
                                placeholder=""
                                label="Report Type"
                                selectedKeys={[String(formData.reportType)]}
                                selectionMode="single"
                                onChange={handleChange}
                                variant="flat"
                                color="warning"
                            >
                                {(list) => (
                                    <SelectItem
                                        key={list.key}
                                    >
                                        {list.value}
                                    </SelectItem>
                                )}
                            </Select>
                        </div>
                        <div className="flex gap-4 align-top items-center mb-2">
                            {isUseMfgNoAsMktno ? "" : <>
                                <Select
                                    size="sm"
                                    name={"updateBy"}
                                    className="w-1/2"
                                    classNames={{
                                        label: " font-semibold text-sm",
                                    }}
                                    isMultiline={true}
                                    isRequired
                                    placeholder=""
                                    label="Update Key"
                                    selectedKeys={[selUpdateKey]}
                                    selectionMode="single"
                                    onChange={(e) => handleUpdateKeyChange(e.target.value)}
                                    variant="flat"
                                    color="warning"
                                >

                                    <SelectItem
                                        key={"0"}
                                    >
                                        Marketing No.
                                    </SelectItem>
                                    <SelectItem
                                        key={"1"}
                                    >
                                        Manufacturing No.
                                    </SelectItem>

                                </Select>
                                <Checkbox size="sm"
                                    isDisabled={selUpdateKey == "1" ? false : true}
                                    classNames={{ "label": "text-white " }}
                                    className="py-1 px-2 rounded-md bg-green-800 border-blue-200 text-rose-700 border-0" label="gfu" color={"success"}
                                    isSelected={isRegenMktNo}
                                    onValueChange={(e) => setIsRegenMktNo(e)}>
                                    Regenrate Marketing No.</Checkbox></>
                            }
                        </div>
                        <div className="flex gap-4 align-top items-baseline mb-2">
                            {formData && formData.certifiedFrom != "" && formData.certifiedFrom != null ?
                                <div>  <Button size="sm" auto color="warning" onPress={handleDownloadExcel} className="ml-4"
                                    startContent={<FontAwesomeIcon icon={faDownload} />} >
                                    Upload Excel Format
                                </Button></div> : ""}
                            <Autocomplete
                                size="sm"
                                name={"location"}
                                label={"Stock Location"}
                                eventResizeFeature={true}
                                selectionMode="single"
                                showScrollIndicators={true}
                                //labelPlacement={"outside"}
                                placeholder={""}
                                color="success"
                                className="max-w-23 font-semibold"
                                classNames={{
                                    label: "font-semibold",
                                }}
                                isClearable={false}
                                isVirtualized
                                // readonly={isNewEntry ? false : true}
                                defaultItems={
                                    stockLocData
                                }
                                onSelectionChange={(e) =>
                                    handleAutoCompleteChange(e, "location")
                                }
                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                //onChange={handleFormSelectionChange}
                                selectedKey={formData.location}
                            >
                                {(list) => (
                                    <AutocompleteItem

                                        key={list.AC_ID}
                                    >
                                        {list.AC_DESC}
                                    </AutocompleteItem>
                                )}
                            </Autocomplete>
                        </div>
                        <div>
                            {excelData && excelData.length > 0 ? <h2 className="text-red-600 mt-3 font-semibold  p-2 bg-gray-50"> Total No Of Packets: {excelData.length} </h2> : ""}
                        </div>
                        <div className="flex  justify-center gap-4 align-top items-center mb-2">
                            <Button
                                color="primary"
                                type="submit"
                                size="sm"
                                variant="shadow"
                                isLoading={isPending}
                                isDisabled={isPending}
                                startContent={<FontAwesomeIcon icon={faSave} />}
                            >
                                Update Data
                            </Button>
                            <Button
                                color="danger"
                                size="sm"
                                variant="shadow"
                                startContent={<FontAwesomeIcon icon={faCancel} />}
                                onPress={handleCancle}
                            >
                                cancle
                            </Button>
                        </div>
                        <div>
                            {dupMfgCode && dupMfgCode.length > 0 ? (
                                <div className=" bg-lime-50 p-2 text-sm mt-2">
                                    <h2 className="p-2  text-sm  font-semibold text-blue-700">   Duplicate Manufacturing Nos:</h2>
                                    <div className="flex gap-2 flex-wrap">
                                        {dupMfgCode.map((ele, i) => (
                                            <div key={i}>
                                                {ele.SL_CODE}-{ele.SPKTNO} ,
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        <div>
                            {notExistMfglotPkt && notExistMfglotPkt.length > 0 ? (
                                <div className=" bg-rose-50 p-2 text-sm mt-2">
                                    <h2 className="p-2  text-sm  font-semibold text-blue-700">Manufacturing Nos. Not Exist In Stock :</h2>
                                    <div className="flex gap-2 flex-wrap">
                                        {notExistMfglotPkt.map((ele, i) => (
                                            <div key={i}>
                                                {ele.L_CODE}-{ele.PKTNO} ,
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </CardBody>
                </form>
            </Card></div>}


        </MainContainer>
    )
}
export default UploadStockParam